<template>
  <div class="history-list-wrapper">
    <ErrorMessage
      v-if="getHistoryState.error.history"
      :header="$t('common.error.api')"
      :content="$t('common.error.api_content')"
    />
    <HistoryLoader v-else-if="getHistoryState.loading.history" />
    <HistoryTable v-else />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { IHistoryState, store } from '@/store/modules/history/types';
import ErrorMessage from '@/components/common/ErrorMessage/ErrorMessage.vue';
import HistoryLoader from './components/HistoryLoader/HistoryLoader.vue';
import HistoryTable from './components/HistoryTable/HistoryTable.vue';
import './styles/history-list.scss';

@Component({
  components: {
    ErrorMessage,
    HistoryLoader,
    HistoryTable
  }
})
export default class HistoryList extends Vue {
  @store.Getter
  private getHistoryState!: IHistoryState;
}
</script>
